var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leadership",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "leadership-2",
    "data-name": "leadership",
    transform: "translate(23449.701 -18482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3252",
    "data-name": "Raggruppa 3252",
    transform: "translate(-23158.055 19116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3250",
    "data-name": "Raggruppa 3250",
    transform: "translate(-2.279 3.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1739",
    "data-name": "Tracciato 1739",
    d: "M605.089,231.088s-3.166-5.63-3.265-6.245-1.682-1.74-1.682-1.74a3.2,3.2,0,0,0-2.362-.727c.352-.3-.9-.5-1-.706s-.4-.2-.792-.512-1.383-.051-1.384-.051a3.869,3.869,0,0,1-.307-1.02,2.914,2.914,0,0,0,.652-1.846c0-.007,0-.015,0-.022l.076.123c.185-1.149.512-2.1-.111-3.151a3.432,3.432,0,0,0-1.942-1.537l-.594.492.231-.573a3.043,3.043,0,0,0-.587-.035l-.534.711.221-.687A3.365,3.365,0,0,0,589.372,215a3.191,3.191,0,0,0,.034,3.448l.006-.021a2.876,2.876,0,0,0,1.416,2.32l.168,1.391h0a.908.908,0,0,1-.551.251c-.3,0-.594.819-.594.819s-.168.088-.35.5a13.172,13.172,0,0,0-2.42,2.085,1.214,1.214,0,0,0-.594,1.3c.1,1.433,0,8.087,0,8.087s-.89,5.631-.594,6.04-.1,1.74-.1,1.74l.3.068v.341s-.893,4.282.495,4.095c2.276-.307.594-3.788.594-3.788v-.4l.4.091s.2-1.433.594-1.536c.138-.036.3-.418.451-.9l.142,1.209.619-.142.172.654a.841.841,0,0,0,.133.062l-.133.757a5.49,5.49,0,0,0,0,1.331c.05.258,1.886,5.776,3.695,11.182l-.034,1.307s-.89,1.024-.693,1.74a58.911,58.911,0,0,1-.495,6.654l-.594,2.969.149.048-.137.52a1,1,0,0,0-.309.251,17.054,17.054,0,0,0-1.781,3.583s-1.781,2.764.989,2.662,2.968-1.126,2.968-1.126.4-2.662.4-2.764-.2-1.155-.2-1.155l-.077-.088.054-1.277.518.165s.495-2.662.891-2.969a14.779,14.779,0,0,0,.927-2.839c.429,1.279.845,5.7.98,6.105a1.469,1.469,0,0,0-.126.214,25,25,0,0,1-1.484,2.559s-3.166,1.945,0,2.457a5.333,5.333,0,0,0,2.671-.512c.891-.614,3.265-1.536,3.265-1.74s-.594-3.214-1.187-2.887h0l-.4-.946.4-.159-2.505-11.634a6.026,6.026,0,0,0,.13-.753c0-.536,1.281-10.975,1.607-13.623,1.435.421,2.746-2.655,2.746-2.655l.325-.606.466.3s.4-1.024.99-1.126,1.682-5.528,1.682-6.245A3.426,3.426,0,0,0,605.089,231.088Zm-4.61,8.021a2.741,2.741,0,0,0-.337-.445,13.02,13.02,0,0,0,.594-2.15,28.2,28.2,0,0,0-.3-4.812l-.009-.25a7.093,7.093,0,0,1,1.1,1.786.777.777,0,0,0,.3.614L601.23,236a13.038,13.038,0,0,0-.495,1.536,5.4,5.4,0,0,0-.1.921l.14.09Z",
    transform: "translate(-544.717 -213.535)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1740",
    "data-name": "Tracciato 1740",
    d: "M245.706,250.831l.528-.123-2.177-6.347-4.7-1.791-.051.056a2.618,2.618,0,0,1-.642-1.442,2.83,2.83,0,0,0,1.6-1.79,2.951,2.951,0,0,0-.311-2.418c.387-.1.526-.46.655-.893a1.677,1.677,0,0,0-.246-.055l.183-.424-.321-.03.082-.4-.41.292a.889.889,0,0,0-.139-.826,1.6,1.6,0,0,0-.685-.5,2.977,2.977,0,0,0-3.136.567l-.03-.119a4.15,4.15,0,0,0-1.52,2.725,4.3,4.3,0,0,0,1.01,3c-.005-.037-.011-.074-.017-.11q.042.06.086.117l.079,3.116-.2.176s-3.33,1.559-3.46,3.421h0c-.2.906-.3,5.616-.3,5.616h.274l-.274,1.843-1.781,7.166s-2.276,3.071-.3,3.685c1.23.382,1.58-1.095,1.67-2.267a.7.7,0,0,0,.7.527l.1.009c-.936,2.5-.3,10.638-.3,10.638-.495,1.024,5.343,8.087,5.343,8.087l.352-.194.076.157c-.2.019-.329.037-.329.037v3.174s-.89,3.174.3,3.788a.826.826,0,0,0,.934-.215c-.059.979-.142,2.441-.142,2.774,0,.512,1.286,1.433,1.286,1.433s.3,1.126,2.671,1.126.594-2.969.594-2.969l-1.286-2.969s-.1.049-.387-.2l.1-1.187.58.053.792-11.978s.693-10.647.792-12.285a11.8,11.8,0,0,0-.036-1.575l2.905-6.206Zm-2.143,3.972-.3,1.07v-2.367Zm-12.352,7.592c0-.375-.015-.63-.015-.63l1.934-4L233.074,259A12.287,12.287,0,0,0,231.21,262.394Zm4.536,11.552,1.88-6.859,1.088,8.292-.078,3.015a4.911,4.911,0,0,1-.318-.865C238.021,276.3,235.746,273.946,235.746,273.946Z",
    transform: "translate(-228.704 -231.383)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1741",
    "data-name": "Tracciato 1741",
    d: "M310.942,277.112c-.927-.395-2.727-1.241-2.945-1.693s-1.309-3.95-1.309-3.95l-.281.021c-.036-1.589-.191-7.748-.428-8.485,0,0,1.145-9.761-1.145-13.655l-.413-1.725a9.96,9.96,0,0,0,.031-2.563c-.109-.339,1.254-1.411.872-2.088s-1.418-2.99-1.418-2.99a3.766,3.766,0,0,0-1.363-2.821s-.43-2.52-2.369-2.558c-.262-.473-.629-1.226-.521-1.561.116-.359.557-1.477.807-2.1a2.587,2.587,0,0,0,.381-.219,4.835,4.835,0,0,0,2.629-4.441,4.77,4.77,0,0,0-2.961-4.577,1.56,1.56,0,0,0-.355-1.637,1.435,1.435,0,0,0-1.594-.306,1.524,1.524,0,0,0-.9,1.4,1.567,1.567,0,0,1,.13-1.433,1.458,1.458,0,0,1,1.227-.679,1.427,1.427,0,0,1,.285.029,1.444,1.444,0,0,0-1.87.553,5.346,5.346,0,0,0,.354,2.153,4.808,4.808,0,0,0-2.767,4.5,4.877,4.877,0,0,0,2.424,4.339,2.93,2.93,0,0,1-.988,2.316,2.48,2.48,0,0,0-1.408-.325c-.2-.159-.5-.212-.9.208a7.869,7.869,0,0,0-1.527,4.4c0,1.354.164,9.2.164,9.2s-.873.339-.273.846a.693.693,0,0,0,.441.169l.6,4.57s-.382,4.4,1.091,4.457a.567.567,0,0,0,.33-.084l-1.093,5.105A16.752,16.752,0,0,0,289.4,266.5a27.109,27.109,0,0,0-1.767,3.39l-.36-.231-1.254,2.483s-2.781,1.749-2.181,3.047a3.877,3.877,0,0,0,1.145,1.636l.382-.169.709,1.354a3.885,3.885,0,0,0,4.853,1.354,1.166,1.166,0,0,0,0-1.354c-.491-.733-1.745-2.313-1.745-2.313l.818-4.288-.169-.109,5.186-6.493a8.429,8.429,0,0,0,2.072-1.806c.545-.846,3.926-9.592,3.926-9.592l1.909,9.141a26.946,26.946,0,0,0,.382,5.473,23.975,23.975,0,0,1,.522,3.657l-.14.011.327,2.539s-1.418,3.611-.436,3.893a13.945,13.945,0,0,0,2.127.395l.109-.395s4.2,2.37,5.726.621C311.542,278.748,311.869,277.507,310.942,277.112ZM296,249.408c.164.169.109.959.109.959l-.327,2.2-.327,1.526a16.934,16.934,0,0,0-.273-2.147l-.151-4.217a.31.31,0,0,0,.1.042c.109,0,.055-.959.055-.959s.064-.171.143-.442c.212.657.471,1.085.784,1.175l.054.734s-.709.338-.054.338a.5.5,0,0,0,.112-.017l-.058.3S295.836,249.239,296,249.408Z",
    transform: "translate(-277.125 -218.255)",
    fill: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_182",
    "data-name": "Ellisse 182",
    cx: 24.931,
    cy: 0.537,
    rx: 24.931,
    ry: 0.537,
    transform: "translate(3.162 66.896)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_184",
    "data-name": "Ellisse 184",
    cx: 17.59,
    cy: 1.388,
    rx: 17.59,
    ry: 1.388,
    transform: "translate(11.643 67.225)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3251",
    "data-name": "Raggruppa 3251",
    transform: "translate(20.161 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1742",
    "data-name": "Tracciato 1742",
    d: "M465.909,550.78l.434,3.035,2.168-.217-.217-3.143Z",
    transform: "translate(-449.179 -490.795)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1743",
    "data-name": "Tracciato 1743",
    d: "M349.51,550.78l-.434,3.035-2.168-.217.217-3.143Z",
    transform: "translate(-343.077 -490.795)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1744",
    "data-name": "Tracciato 1744",
    d: "M449.268,369.9a8,8,0,0,0-1.517,5.853c.434,3.577,1.192,11.705,1.192,11.705l.542,14.415,3.468-.217L453.5,389.4l1.734-9.863,4.66,11.489s2.276,10.73,2.384,10.73,3.251-.325,3.251-.325l-1.517-12.681s-2.384-18.425-3.793-18.75S449.268,369.9,449.268,369.9Z",
    transform: "translate(-445.978 -341.341)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1745",
    "data-name": "Tracciato 1745",
    d: "M586.952,678.21s-1.951-1.3-2.71.217a2.8,2.8,0,0,0-.108,2.6s.65.434.325.867a2.037,2.037,0,0,0,2.384,2.818c2.818-.434,1.409-3.36,1.409-3.36Z",
    transform: "translate(-567.404 -615.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1746",
    "data-name": "Tracciato 1746",
    d: "M451.671,678.21s1.951-1.3,2.71.217a2.8,2.8,0,0,1,.108,2.6s-.65.434-.325.867a2.037,2.037,0,0,1-2.384,2.818c-2.818-.434-1.409-3.36-1.409-3.36Z",
    transform: "translate(-448.055 -615.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1747",
    "data-name": "Tracciato 1747",
    d: "M486.768,171.52s.975,2.71.217,4.227S488.177,179,488.177,179s5.094-2.6,4.444-3.9-1.734-3.035-1.517-4.119Z",
    transform: "translate(-480.822 -164.046)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_188",
    "data-name": "Ellisse 188",
    cx: 3.468,
    cy: 3.468,
    r: 3.468,
    transform: "translate(4.374 1.567)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1748",
    "data-name": "Tracciato 1748",
    d: "M468.785,203.545a3.905,3.905,0,0,0,6.075-1.207l2.7,1.533,1.409,16.474s-7.912,4.552-11.705.65l.542-15.282Z",
    transform: "translate(-463.436 -192.006)",
    fill: "#dfebf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1749",
    "data-name": "Tracciato 1749",
    d: "M326.337,91.488l-4.886,3.248,1.734,8.02-2.276,12.464,3.685-5.528Z",
    transform: "translate(-319.895 -81.572)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1750",
    "data-name": "Tracciato 1750",
    d: "M520.343,190.169l1.2.792,4.877,1.734-.759,13.44,2.059,8.671-2.926,1.517a9.3,9.3,0,0,0-3.9-6.178C517.533,208.086,519.577,190.786,520.343,190.169Z",
    transform: "translate(-509.582 -181.157)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1751",
    "data-name": "Tracciato 1751",
    d: "M445.569,384.478l1.409.975s-1.788,1.9-2.113,1.572a.889.889,0,0,1-.271-.7l-.325-.759Z",
    transform: "translate(-442.928 -354.406)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1752",
    "data-name": "Tracciato 1752",
    d: "M529.43,382.532l-.479.753s-1.409.65-1.084,1.084,3.035,1.409,3.577.434l.542-.975Z",
    transform: "translate(-517.424 -352.671)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1753",
    "data-name": "Tracciato 1753",
    d: "M434.115,227.478l-.759.108-1.246,8.075s-.488,1.463.054,4.931,1.079,5.727,1.079,5.727l2.39-1.717-1.084-2.818,1.409-10.3Z",
    transform: "translate(-431.908 -214.422)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1754",
    "data-name": "Tracciato 1754",
    d: "M542.736,211.478l1.734.217a9.457,9.457,0,0,1,2.276,4.227,83.183,83.183,0,0,1,.217,8.346l-4.986,7.912-2.71-1.951,3.793-6.72-1.843-8.02Z",
    transform: "translate(-527.632 -200.156)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1755",
    "data-name": "Tracciato 1755",
    d: "M475.127,108.918a4.052,4.052,0,0,0-2.3-1.762l-.7.564.274-.658a3.73,3.73,0,0,0-.7-.04l-.634.815.262-.787a4.013,4.013,0,0,0-2.768,1.647,3.562,3.562,0,0,0-.149,3.954c.218-.67.482-1.3.7-1.967a1.982,1.982,0,0,0,.516,0l.265-.619.074.592c.822-.072,2.04-.229,2.819-.373l-.076-.454.453.378c.239-.055.38-.1.369-.143.579.934,1.153,1.53,1.733,2.464C475.479,111.214,475.867,110.119,475.127,108.918Z",
    transform: "translate(-463.977 -107.019)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_189",
    "data-name": "Ellisse 189",
    cx: 0.235,
    cy: 0.47,
    rx: 0.235,
    ry: 0.47,
    transform: "translate(10.723 4.457)",
    fill: "#ffb8b8"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadership);
export default __webpack_public_path__ + "static/media/leadership.bd7c75300b55a11360ddf0e7cabc4d58.svg";
export { ForwardRef as ReactComponent };